import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-auto">
      <FaFacebook size={24} className="mx-2" />
      <FaTwitter size={24} className="mx-2" />
      <FaInstagram size={24} className="mx-2" />
    </footer>
  );
}

export default Footer;

